'use client';

import { Flex, Splitter, SplitterPanelData, useBreakpointValue } from '@chakra-ui/react';
import { useSearchParams } from 'next/navigation';
import { memo, useState } from 'react';

import CreateSignal, { type SignalType } from '@features/create/CreateSignal';
import SignalSummary from '@features/create/SignalSummary';
import { useTreeState } from '@features/create/useTreeState';
import { toPxString } from 'helpers/styles';
import { useGetCommodity } from 'hooks/useGetCommodity';

const HEADER_HEIGHT_PX = 72;
const PANELS: SplitterPanelData[] = [
  {
    id: 'create-signal',
  },
  {
    id: 'summary',
    minSize: 20,
    maxSize: 40,
  },
];
const DEFAULT_SIZE = { base: [60, 40], xl: [70, 30] };

const CreatePage = () => {
  const searchParams = useSearchParams();
  const commodityId = searchParams.get('commodityId');
  const { commodity } = useGetCommodity(commodityId ?? '');
  const { blocks, addBlock, updateBlock, removeBlock } = useTreeState({
    initialCommodity: commodity,
  });
  const size = useBreakpointValue(DEFAULT_SIZE);
  const [signalType] = useState<SignalType>('demand');

  return (
    <Flex w="full" h="full" gap={4}>
      <Splitter.Root panels={PANELS} orientation="horizontal" size={size}>
        <Splitter.Panel id="create-signal">
          <CreateSignal
            headerHeight={toPxString(HEADER_HEIGHT_PX)}
            blocks={blocks}
            addBlock={addBlock}
            updateBlock={updateBlock}
            removeBlock={removeBlock}
            signalType={signalType}
          />
        </Splitter.Panel>
        <Splitter.ResizeTrigger id="create-signal:summary" hideBelow="lg" disabled>
          <Splitter.ResizeTriggerSeparator bg="border.light" />
        </Splitter.ResizeTrigger>
        <Splitter.Panel id="summary" hideBelow="lg">
          <SignalSummary blocks={blocks} headerHeight={toPxString(HEADER_HEIGHT_PX)} />
        </Splitter.Panel>
      </Splitter.Root>
    </Flex>
  );
};

export default memo(CreatePage);
